export default{
    loading: false,
    error: "",
    page: {},
    channels: [],
    packages: [],
    autocompleteResult : []
}